import { downloadPlatforms, updateLogs } from "@/mocks/siteData";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function AppDownload() {
  return (
    <section id="download" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="APP 下载"
          title="手机、平板、电脑，选一个系统就能开始"
          desc="包子漫画客户端覆盖 iOS、Android、Windows 与 macOS，账号与网页版互通。下面是各端的基本信息，安装步骤统一放在「使用教程」里说明，点卡片右下角即可跳转查看。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {downloadPlatforms.map((p) => (
            <article
              key={p.name}
              className="reveal flex h-full flex-col rounded-lg border border-background-200 bg-background-100/60 p-6 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-2xl`} aria-hidden="true" />
                </span>
                <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                  {p.version}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg text-foreground-950">{p.name}</h3>
              <p className="mt-1.5 text-xs text-foreground-500">{p.meta}</p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{p.note}</p>
              <div className="mt-auto flex items-center justify-between pt-5">
                <span className="text-xs text-foreground-500">安装包约 {p.size}</span>
                <a
                  href="#guide"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  查看安装步骤
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="reveal mt-14 grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-2">
          <div>
            <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
              <i className="ri-file-list-3-line text-xl text-primary-600" aria-hidden="true" />
              近期版本更新
            </h3>
            <div className="mt-5 flex flex-col gap-5">
              {updateLogs.map((log) => (
                <div key={log.version} className="border-l-2 border-primary-200 pl-4">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-medium text-foreground-950">{log.version}</span>
                    <span className="text-xs text-foreground-500">{log.date}</span>
                  </div>
                  <ul className="mt-2 flex flex-col gap-1.5">
                    {log.items.map((item) => (
                      <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-600">
                        <i className="ri-check-line mt-1 text-secondary-600" aria-hidden="true" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-center rounded-lg bg-foreground-900 p-6 text-background-100 md:p-8">
            <h3 className="flex items-center gap-2 font-heading text-lg">
              <i className="ri-smartphone-line text-xl text-secondary-300" aria-hidden="true" />
              下载前的小提示
            </h3>
            <ul className="mt-5 flex flex-col gap-3 text-sm leading-relaxed text-background-100/85">
              <li className="flex gap-2">
                <i className="ri-information-line mt-0.5 text-secondary-300" aria-hidden="true" />
                请通过官方渠道获取安装包，避免使用来源不明的第三方安装文件。
              </li>
              <li className="flex gap-2">
                <i className="ri-information-line mt-0.5 text-secondary-300" aria-hidden="true" />
                首次安装若被系统拦截，可在设置中允许“安装未知来源应用”。
              </li>
              <li className="flex gap-2">
                <i className="ri-information-line mt-0.5 text-secondary-300" aria-hidden="true" />
                客户端与网页版使用同一账号，登录后书架与进度会自动同步。
              </li>
              <li className="flex gap-2">
                <i className="ri-information-line mt-0.5 text-secondary-300" aria-hidden="true" />
                桌面端建议保留至少 2GB 可用空间，方便离线缓存章节。
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}